import { Component, OnInit, Input } from '@angular/core';
import {
  Router
} from '@angular/router';
import { PracticeService } from '../../../core/services/v2/practice.service';
import { UserService } from '../../../core/services/v2/user.service';

@Component({
  selector: 'app-layoutheader',
  templateUrl: './layoutheader.component.html',
  styleUrls: ['./layoutheader.component.scss']
})

export class LayoutheaderComponent implements OnInit {
  @Input() photoUrlRecieve: string;
  userName: string;
  greetings: string;
  shortName: string;
  constructor(private router: Router, private practiceService: PracticeService, private userService: UserService) { }

  ngOnInit() {
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.userName = userDetails.name;
        const userNameArray = this.userName.split(" ");
        this.shortName = userNameArray[0][0];
        //for (let name of userNameArray) {
        //  this.shortName += name[0];
        //}
      },
      (error) => { console.error(error); }
    );


    const today = new Date();
    const curHr = today.getHours();

    if (curHr < 12) {
      this.greetings = 'Good Morning';
    } else if (curHr < 18) {
      this.greetings = 'Good Afternoon';
    } else {
      this.greetings = 'Good Evening';
    }

  }

  hasPractitionerProfile() {
    if (this.practiceService.getCurrentUser()) {
      return this.practiceService.getCurrentUser().practitionerId > 0 && this.practiceService.isCurrentUserActive();
    }

    return false;
  }

  signOut() {
    window.location.href = `/Session/SignOut`;
  }

  settingPage() {
    this.router.navigate(['physician/profile/signIn']);

  }
}
